import '../../styles/components/accordion.scss'

class Accordion extends HTMLElement {
  constructor() {
    super();

    this.label = this.querySelector('label');
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.content = this.querySelector('.accordion__content');
    this.contentInner = this.querySelector('.accordion__content-inner');
    this.parentAccordion = this.parentNode.closest('accordion-item');

    this.label.addEventListener('click', this.onItemClick.bind(this));
  }

  onItemClick(event) {
    event.preventDefault();

    if (this.checkbox.checked) {
      this.checkbox.checked = false;
    } else {
      const accordionContentHeight = this.contentInner.clientHeight + "px";

      this.content.style.setProperty('--max-height', accordionContentHeight);

      this.checkbox.checked = true;

      if (this.parentAccordion) {
        this.parentAccordion.updateParentHeight(accordionContentHeight);
      }
    }
  }

  updateParentHeight(additionalHeight) {
    const newHeight = this.contentInner.clientHeight + additionalHeight + "px";

    this.content.style.setProperty('--max-height', newHeight);

    if (this.parentAccordion) {
      this.parentAccordion.updateParentHeight(newHeight);
    }
  }
}

try {
  customElements.define('accordion-item', Accordion);
}
catch(e) {}
